/**
 * SecondaryBanner content for the brand SchoolShop pages (Figma 8746:73145).
 *
 * - tag   = the open shop's name (e.g. "Studieturstrøjer" / "Overalls & More"):
 *           the variations payload's shop, else the URL's shop, else the
 *           school's single open shop. No shop resolved (still loading, or
 *           2+ open shops and none chosen) → '' → the banner is not rendered.
 * - title = "School / Class" (class omitted when none is chosen).
 * - menuItemKey = the resolved shop's menu item, for per-shop banner photos.
 *
 * On a group ("sub-shop") page pass `currentGroup` (the variations payload's
 * `group`): the tag becomes the group name and the group's menu item wins
 * over the shop's, so a Vogntrøjer group inside the Studieturstrøjer shop gets
 * its own banner photo.
 */
export default function schoolShopBanner({ schools, schoolSlug, shopSlug, currentShop, currentGroup, school, className }) {
  const openShops = (schools || []).find((s) => s.slug === schoolSlug)?.seasons || [];
  const shop = currentShop
    ?? (shopSlug
      ? openShops.find((s) => s.slug === shopSlug)
      : (openShops.length === 1 ? openShops[0] : null));

  return {
    tag: currentGroup?.name ?? shop?.name ?? '',
    // Header menu item the group/shop belongs to (menu_1 / menu_2) — lets a
    // brand pick a banner photo per shop type.
    menuItemKey: currentGroup?.menuItemKey ?? shop?.menuItemKey ?? null,
    title: school?.name
      ? `${school.name}${className ? ` / ${className}` : ''}`
      : '',
  };
}
